import { render, staticRenderFns } from "./ladderdetails.vue?vue&type=template&id=0bf1331a"
import script from "./ladderdetails.vue?vue&type=script&lang=js"
export * from "./ladderdetails.vue?vue&type=script&lang=js"
import style0 from "./ladderdetails.vue?vue&type=style&index=0&id=0bf1331a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports